(() => {
  const state = document.getElementById('dealer-price-sync');
  if (!state || window.Shopify?.designMode || window.dealerPriceRefreshInstalled) return;
  window.dealerPriceRefreshInstalled = true;
  const root = window.Shopify?.routes?.root || '/';
  const initialIdentity = state.dataset.dealerIdentity;
  let running = null;
  let queued = false;
  let lastCheck = 0;
  const message = text => {state.textContent = text;state.hidden = !text;};
  const lock = value => document.documentElement.toggleAttribute('data-dealer-price-refreshing',value);
  const request = async (path, options = {}) => {
    const response = await fetch(root + path,{credentials:'same-origin',cache:'no-store',...options});
    if (!response.ok) throw new Error('Price refresh failed');
    return response.json();
  };
  let mappingPromise;
  const legacyMapping = () => {
    if (state.dataset.legacyMigration !== 'true') return Promise.resolve(null);
    return mappingPromise ||= fetch(state.dataset.legacyMapUrl, {cache:'no-store'}).then(response => {
      if (!response.ok) throw new Error('Legacy mapping unavailable');
      return response.json();
    }).then(mapping => {
      if (mapping.version !== 1 || !mapping.products || !mapping.variants || !window.DealerLegacyMigration) throw new Error('Legacy mapping invalid');
      return mapping;
    });
  };
  const updateProductDisplay = () => {
    document.querySelectorAll('[data-dealer-native-price]').forEach(wrapper => {
      const native = wrapper.firstElementChild;
      const ready = !!native && /[¥￥]|JPY|円/.test(wrapper.innerText || '');
      wrapper.toggleAttribute('data-ready',ready);
    });
    document.querySelectorAll('.product-info').forEach(info => {
      info.toggleAttribute('data-dealer-native-ready',!!info.querySelector('[data-dealer-native-price][data-ready]'));
    });
  };
  const sectionOf = element => element?.closest('[id^="shopify-section-"]')?.id.replace(/^shopify-section-/,'');
  const refresh = () => {
    if (running) return running;
    running = (async () => {
      const visible = document.querySelector('#cart-drawer[open]') || document.querySelector('.cart-page') || document.querySelector('#cart-drawer');
      const shownTotal = visible?.querySelector(".cart-drawer__button-price,[data-cart-total]")?.textContent;
      const oldTotal = shownTotal ? Math.round(Number(shownTotal.replace(/[^0-9.]/g,""))*100) : visible?.dataset.dealerCartTotal;
      message('');lock(true);
      const drawer = document.getElementById('cart-drawer');
      const page = document.querySelector('.cart-page')?.closest('[id^="shopify-section-"]');
      const drawerSection = sectionOf(drawer);
      const pageSection = sectionOf(page);
      const sections = [...new Set([drawerSection,pageSection,state.dataset.sectionId].filter(Boolean))];
      const before = await request('cart.js');
      const mapping = await legacyMapping();
      const migration = mapping ? window.DealerLegacyMigration.plan(before, mapping) : {updates:{}, migrated:false};
      const cart = await request('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:migration.updates,attributes:{__dealer_price_refresh:String(Date.now())},sections,sections_url:location.pathname})});
      if (migration.migrated && (cart.item_count !== before.item_count || cart.items.some(item => mapping.variants[String(item.variant_id)]))) throw new Error('Legacy migration incomplete');
      const parsed = id => new DOMParser().parseFromString(cart.sections?.[id] || '', 'text/html');
      const freshState = parsed(state.dataset.sectionId).querySelector('[data-dealer-identity]');
      if (!freshState) throw new Error('Identity unavailable');
      if (freshState.dataset.dealerIdentity !== initialIdentity) {location.reload();return {redirecting:true};}
      if (drawer && drawerSection) {
        const source = parsed(drawerSection).querySelector('#cart-drawer');
        if (!source) throw new Error('Drawer unavailable');
        drawer.replaceChildren(...source.childNodes);
        drawer.dataset.dealerCartTotal = String(cart.total_price);
        drawer.classList.toggle('drawer--center-body',cart.item_count === 0);
      }
      if (page && pageSection) {
        const source = parsed(pageSection).getElementById(page.id);
        if (!source) throw new Error('Cart page unavailable');
        page.replaceChildren(...source.childNodes);
      }
      const freshCart = {...cart};
      const nativeEvent = new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'dealer:refresh',cart:freshCart}});
      document.documentElement.dispatchEvent(nativeEvent);
      const changed = migration.migrated || Number(oldTotal ?? before.total_price) !== cart.total_price;
      lastCheck = Date.now();lock(false);updateProductDisplay();
      if (changed) message(migration.migrated ? '商品を最新の注文ページに切り替えました。数量と金額をご確認ください。' : state.dataset.changedText);
      return {changed,total:cart.total_price};
    })().catch(error => {message(error.message?.startsWith('旧商品') ? error.message : state.dataset.errorText);return null;}).finally(() => {
      running = null;
      if (queued) {queued = false;refresh();}
    });
    return running;
  };
  const continueCheckout = async () => {
    const result = await refresh();
    if (result && !result.redirecting && !result.changed) location.assign(root + 'checkout');
  };
  document.addEventListener('submit',event => {
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();event.stopImmediatePropagation();continueCheckout();
  },true);
  document.addEventListener('click',event => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[name="checkout"]');
    const link = target?.closest('a[href]');
    let checkoutLink = false;
    if (link) {
      const url = new URL(link.href,location.href);
      checkoutLink = url.origin === location.origin && /^\/checkout(?:\/|$)/.test(url.pathname);
    }
    if (!button && !checkoutLink) return;
    event.preventDefault();event.stopImmediatePropagation();continueCheckout();
  },true);
  document.addEventListener('cart:change',event => {
    if (event.detail?.baseEvent === 'dealer:refresh') return;
    if (running) queued = true;else refresh();
  });
  document.addEventListener('dialog:after-show',event => {
    if (event.target.id === 'cart-drawer' && Date.now()-lastCheck > 500) refresh();
  });
  window.addEventListener('pagehide',() => {message('');lock(true);});
  window.addEventListener('pageshow',event => {if(event.persisted) refresh();});
  window.addEventListener('focus',() => {if(Date.now()-lastCheck > 1000) refresh();});
  document.addEventListener('visibilitychange',() => {if(document.visibilityState === 'visible' && Date.now()-lastCheck > 1000) refresh();});
  const start = async () => {
    try {
      const mapping = await legacyMapping();
      const destination = mapping && window.DealerLegacyMigration.redirect(location.href, mapping, root);
      if (destination) {location.replace(destination);return;}
    } catch (error) {lock(true);message(error.message?.startsWith('旧商品') ? error.message : state.dataset.errorText);return;}
    updateProductDisplay();
    const observer = new MutationObserver(updateProductDisplay);
    observer.observe(document.getElementById('main') || document.body,{childList:true,subtree:true,characterData:true});
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

